(function () {

  const banner = document.querySelector('.js-banner')
  
  if (!banner) return;

  hideOnScroll()

  window.addEventListener('scroll', () => {
    hideOnScroll()
  })

  function hideOnScroll () {
    if (window.scrollY > 50) {
      banner.classList.add('collapsed')
    } else {
      banner.classList.remove('collapsed')
    }
  }

})()
